import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store';
import { ssrCompileToFunctions } from 'vue-template-compiler';

Vue.use(Router)

// Layout
const Layout = () => import('@/components/Layout/Layout')

//Home
const Home = () => import('@/views/Home')

//Autenticacao
const Login = () => import('@/views/Autenticacao/Login')
const EsqueceuSenha = () => import('@/views/Autenticacao/EsqueceuSenha')

//Aluno
const ListarAluno = () => import('@/views/Aluno/Listar')
const DetalheAluno = () => import('@/views/Aluno/Detalhe')
const EditarAluno = () => import('@/views/Aluno/Editar')

//Cobrança
const ListarCobranca = () => import('@/views/Cobranca/Listar')
const DetalheCobranca = () => import('@/views/Cobranca/Detalhe')

//Pagamento
const ListarPagamento = () => import('@/views/Pagamento/Listar')
const DetalhePagamento = () => import('@/views/Pagamento/Detalhe')

//Acompanhamento
const ListarAcompanhamento = () => import('@/views/Acompanhamento/Listar')

//Matricula
const ListarMatricula = () => import('@/views/Matricula/Listar')
const DetalheMatricula = () => import('@/views/Matricula/Detalhe')

//Solicitação
const ListarSolicitacao = () => import('@/views/Secretaria/Solicitacao/Listar');
const CriarSolicitacao = () => import('@/views/Secretaria/Solicitacao/Criar');
const DetalheSolicitacao = () => import('@/views/Secretaria/Solicitacao/Detalhe');

//HistoricoEscolar
const ListarHistorico = () => import('@/views/HistoricoEscolar/Listar');
const DetalheHistorico = () => import('@/views/HistoricoEscolar/Detalhe');


const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/',
            name: 'Layout',
            meta: {
                requiresAuth: true
            },
            component: Layout,
            children: [
                {
                    path: '',
                    name: 'Home',
                    component: Home
                },
                {
                    path: 'aluno',
                    redirect: '/aluno',
                    name: 'Aluno',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Lista Alunos',
                            component: ListarAluno
                        },
                        {
                            path: ':id',
                            name: 'Detalhe Aluno',
                            component: DetalheAluno
                        },
                        {
                            path: 'editar/:id',
                            name: 'Editar Aluno',
                            component: EditarAluno,
                        },
                    ]
                },
                {
                    path: '/acompanhamento',
                    redirect: '/acompanhamento',
                    name: 'Acompanhamento',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Lista de Acompanhamento',
                            component: ListarAcompanhamento
                        },
                    ]
                },
                {
                    path: 'cobranca',
                    redirect: '/cobranca',
                    name: 'Cobrança',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Lista de Cobrança',
                            component: ListarCobranca
                        },
                        {
                            path: ':id',
                            name: 'Detalhe Cobrança',
                            component: DetalheCobranca
                        },
                    ]
                },
                
                {
                    path: 'pagamento',
                    redirect: '/pagamento',
                    name: 'Pagamento',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Lista de pagamento',
                            component: ListarPagamento
                        },
                        {
                            path: ':id',
                            name: 'Detalhe pagamento',
                            component: DetalhePagamento
                        },
                    ]
                },
                {
                    path: '/historico-escolar',
                    redirect: '/historico-escolar',
                    name: 'HistoricoEscolar',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Lista de Históricos',
                            component: ListarHistorico
                        },
                        {
                            path: ':id',
                            name: 'Detalhe Historico',
                            component: DetalheHistorico
                        }
                    ]
                },
                {
                    path: 'matricula',
                    redirect: '/matricula',
                    name: 'Matricula',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Listar Matriculas',
                            component: ListarMatricula
                        },
                        {
                            path: ':id',
                            name: 'Detalhe Matriculas',
                            component: DetalheMatricula
                        }
                    ]
                },
                {
                    path: 'secretaria',
                    redirect: '/secretaria',
                    name: 'Secretaria',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'solicitacao',
                            redirect: '/solicitacao',
                            name: 'Solicitação',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Lista de solicitação',
                                    component: ListarSolicitacao
                                },
                                {
                                    path: 'criar/:id?',
                                    name: 'Criação de solicitação',
                                    component: CriarSolicitacao
                                },
                                {
                                    path: ':id',
                                    name: 'Detalhe de solicitação',
                                    component: DetalheSolicitacao
                                },
                            ]
                        },
                    ]
                }
            ]
        },
        {
            path: '/autenticacao',
            redirect: '/autenticacao/login',
            name: 'Autenticacao',
            component: {
                render(c) { return c('router-view') }
            },
            children: [
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'esqueceu-senha',
                    name: 'Esqueceu Senha',
                    component: EsqueceuSenha
                }
            ]
        },
    ]
})

/**
 * @desc Cria uma barreira de acesso aos urls, bloqueando somente para usuários autenticados usando "navigation guards"
 * @about https://router.vuejs.org/guide/advanced/navigation-guards.html
 */
router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters.isAuthenticated;
    

    if (to.matched.some(route => route.meta.requiresAuth)) {
        let host = window.location.hostname;
        let href = window.location.href;
         
        // Check permission for commercial profile
        if (store.getters.permission != null && store.getters.permission == 4){
            if (to.fullPath != '/' && !to.fullPath.startsWith('/aluno') && !to.fullPath.startsWith('/matricula') && !to.fullPath.startsWith('/acompanhamento')) {
                next("/");
                return;
            }
        }
        if(host == "vestibular.uca.edu.br" && href != "http://vestibular.uca.edu.br/#/vestibular-presencial") {
            next("/vestibular-presencial/");
        }else{
            if (!isAuthenticated) {
                next("/autenticacao/login");
            } else {
                next();
            }
        }
        if(host == "vestibular.esn.edu.br" && href != "http://vestibular.esn.edu.br/#/vestibular-esn") {
            next("/vestibular-esn/");
        }else{
            if (!isAuthenticated) {
                next("/autenticacao/login");
            } else {
                next();
            }
        }

        if(host == "vestibular.uca.edu.br" && href != "http://vestibular.uca.edu.br/#/inscricao-posgrad") {
            next("/inscricao-posgrad/");
        }else{
            if (!isAuthenticated) {
                next("/autenticacao/login");
            } else {
                next();
            }
        }

        // Check permission for the vestibular URL.
        if(host == "vestibular.uca.edu.br" && href != "http://vestibular.uca.edu.br/#/vestibular-ead") {
            next("/vestibular-ead/");
        }else{
            if (!isAuthenticated) {
                next("/autenticacao/login");
            } else {
                next();
            }
        }
    } else if (to.fullPath === "/autenticacao/login" || to.fullPath === "/autenticacao/esqueceu-senha") {
        if (!isAuthenticated) {
            next();
        } else {
            next("/");
        }
    } else {
        next();
    }
});

export default router;
